import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchCombiOpdrachten'
import type { CombiOpdrachtenSearch } from '../types/CombiOpdrachtenSearch'

export { useCombiOpdrachtenSearchStore }

const useCombiOpdrachtenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<CombiOpdrachtenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
